import tooltipTypes from 'helpers/enums/tooltipTypes'
import lessonTypes from 'helpers/enums/lessonTypes'
import lessonStatusTypes from 'helpers/enums/lessonStatusTypes'
import libraryTypes from 'helpers/enums/libraryTypes'

const cached_entity = {}

const buildFormattedActions = (item, canAddToFolder) => {
	const actions = item.data.actions
	const addingActions = ['canAddToBinder', 'canAddToDistrictLibraryId', 'canAddToSchoolLibraryId', 'canAddToPublicLibrary']
	let collapsedActions = []
	// We're removing for now the possibility to add a lesson
	// from the Library to a binder
	actions.canAddToBinder = false
	for (const actionName in actions) {
		if (actions[actionName] !== false) {
			if (addingActions.indexOf(actionName) !== -1) {
				collapsedActions.push({
					name: actionName,
				})
			}
		}
	}
	if (collapsedActions.length) {
		if (canAddToFolder) {
			collapsedActions.push({
				name: 'canAddToFolder',
			})
		}
	}
	//If there is only one collapsable action, we're not collapsing the group
	if (collapsedActions.length === 1) {
		collapsedActions = []
	}

	const formattedActions = {
		share: {
			active: !!actions.canShare,
		},
		edit: {
			active: !!actions.canEdit,
		},
		duplicate: {
			active: !!actions.canDuplicate,
		},
		removeFromFolder: {
			active: !!item.data.folderId,
		},
		addToSchoolLibraryId: {
			active: actions.canAddToSchoolLibraryId && !collapsedActions.length,
		},
		addToDistrictLibraryId: {
			active: actions.canAddToDistrictLibraryId
				&& !collapsedActions.length,
		},
		addToPublicLibrary: {
			active: actions.canAddToPublicLibrary && !collapsedActions.length,
		},
		addToFolder: {
			active: canAddToFolder
				&& !!actions.canAddToFolder
				&& !collapsedActions.length,
		},
		exportPDF: {
			active: !!actions.canExportPDF,
		},
		delete: {
			active: !!actions.canDelete,
		},
		addTo: {
			active: !!collapsedActions.length,
			children: collapsedActions,
		},
		reports: {
			active: item.library_object_type == '1',
		},
		drag: {
			active: canAddToFolder
				&& !!actions.canAddToFolder,
		},
	}
	return formattedActions
}

function canAddToBothLibraries(actions) {
	if (!actions.addTo || !actions.addTo.active) {
		return false
	}
	const children = actions.addTo.children
	let i = 0
	const len = children.length
	let count = 0
	while (i < len) {
		if (children[i].name === 'canAddToDistrictLibraryId' || children[i].name === 'canAddToSchoolLibraryId') {
			count += 1
		}
		i += 1
	}
	return count >= 2
}

function isExternalLibrary(libraryType) {
	const externalLibraries = [libraryTypes.LTI, libraryTypes.TEAMS, libraryTypes.EXTENSION]
	return externalLibraries.includes(libraryType)
}

function formatLesson(
	entity,
	libraryType,
	canAddToFolder = true,
	tooltipType = tooltipTypes.NONE,
	canLaunchSessionWithZoom = false,
	canLaunchSessionWithMSFTTeams = false,
	canTeachNotDownloadedLesson = false,
	canEditLesson = false,
	hasNewTeachModal = false,
) {

	const entity_uid = entity.data.entityUID
	// to avoid entity cache add validation to format it
	if (
		!cached_entity[entity_uid]
		|| cached_entity[entity_uid].entity !== entity
		|| cached_entity[entity_uid].entity.tooltipType !== tooltipType
	) {
		const isLessonPublished = entity.data.state === lessonStatusTypes.PUBLISHED
		const canLaunchFrontOfTheClassroom =
			isLessonPublished && entity.data.type === lessonTypes.VIDEO && libraryType === libraryTypes.REGULAR
		const canLaunchHomework = isLessonPublished && entity.library_object_type === '1'

		const actions = buildFormattedActions(entity, canAddToFolder)
		const canAddToSchoolLibraryId = actions.addToSchoolLibraryId && actions.addToSchoolLibraryId.active
		const canAddToDistrictLibraryId = actions.addToDistrictLibraryId && actions.addToDistrictLibraryId.active
		const canAddToBoth = !canAddToSchoolLibraryId && !canAddToDistrictLibraryId && canAddToBothLibraries(actions)

		const canLaunchSession = canLaunchHomework &&
			(libraryType !== libraryTypes.TEAMS || canLaunchSessionWithMSFTTeams)

		const formattedEntity = {
			...entity,
			canLaunchSession,
			canLaunchHomework,
			canLaunchSessionWithZoom: canLaunchSessionWithZoom && canLaunchSession &&
				(!canLaunchFrontOfTheClassroom || hasNewTeachModal) && !isExternalLibrary(libraryType),
			canLaunchFrontOfTheClassroom,
			canPublish: entity.data.state === 0 && entity.library_object_type === '1',
			canAddToSchoolLibraryId,
			canAddToDistrictLibraryId,
			canAddToBoth,
			canTeachLesson: canTeachNotDownloadedLesson || isLessonPublished,
			canEditLesson: canEditLesson && actions.edit.active,
			formattedActions: actions,
			tooltipType,
		}
		cached_entity[entity_uid] = {
			entity,
			formattedEntity,
		}
	}
	return cached_entity[entity_uid].formattedEntity
}

export default formatLesson
